import addressesReducers from './reducers';

export * from './selectors';

export { default as addressesTypes } from './types';

export { default as addressesActions } from './actions';

export default addressesReducers;
